import { Outlet, useLocation } from "@remix-run/react";
import { Stepper } from "~/components/Stepper";

const excludedPaths = ["pay", "get-started"];

export function Logo() {
  return (
    <div className="flex gap-3 md:items-center md:justify-center">
      <img
        src="/logo.png"
        alt="Power to live logo"
        className="aspect-square size-16 object-contain mix-blend-multiply"
      />
      <h1 className="text-4xl font-bold uppercase text-primary-600">
        Power To Live Foundation
      </h1>
    </div>
  );
}

export default function Register() {
  const location = useLocation();

  const routesWithoutStepper = excludedPaths.some((path) =>
    location.pathname.toLowerCase().includes(path.toLowerCase()),
  );

  return (
    <main className="bg-neutral-50 px-4 py-6 md:px-12">
      <Logo />
      {!routesWithoutStepper && <Stepper />}
      <div className="m-auto max-w-screen-lg">
        <Outlet />
      </div>
    </main>
  );
}
